function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Icon } from "../../Icon/Icon/Icon";
import { FocusedAtMidLine } from "../../Utility/FocusedAtMidLine";
import { Button } from "../../Button/Button/Button";
import styles from "./SectionFive.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionFive = function SectionFive(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    sections = _ref.sections,
    footerText = _ref.footerText,
    button = _ref.button;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.sectionFive,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [heading && /*#__PURE__*/_jsx(HeadingText, {
        richText: true,
        align: "left",
        className: styles.heading,
        typog: heading.typog,
        ariaLevel: heading.ariaLevel,
        children: heading.text
      }), subheading && /*#__PURE__*/_jsx(HeadingText, {
        richText: true,
        align: "center",
        className: styles.subheading,
        typog: subheading.typog,
        ariaLevel: subheading.ariaLevel,
        children: subheading.text
      }), sections === null || sections === void 0 ? void 0 : sections.map(function (section, index) {
        return /*#__PURE__*/_jsx("div", {
          className: styles.section,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.fadeWrapper,
            children: /*#__PURE__*/_jsxs("div", {
              className: classnames(styles.columns, {
                [styles.reverse]: index % 2 !== 0
              }),
              children: [/*#__PURE__*/_jsx("div", {
                className: classnames(styles.left, styles.desktop),
                children: /*#__PURE__*/_jsx(Image, _objectSpread({
                  className: styles.image
                }, section.image.desktop))
              }), /*#__PURE__*/_jsx("div", {
                className: styles.center,
                children: /*#__PURE__*/_jsx(FocusedAtMidLine, {
                  atMidLineClassName: styles.focusedAtMidLine,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: styles.circle,
                    children: [(section === null || section === void 0 ? void 0 : section.arrow) && /*#__PURE__*/_jsx(Icon, {
                      className: classnames(styles.arrow, styles[section.arrow]),
                      type: "inside-bubble-arrow"
                    }), /*#__PURE__*/_jsx("div", {
                      className: styles.number,
                      children: section.number
                    }), /*#__PURE__*/_jsx(Text, {
                      richText: true,
                      align: "center",
                      className: styles.statistic,
                      typog: "subhead3",
                      children: section.statistic
                    })]
                  })
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.right,
                children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                  className: classnames(styles.image, styles.mobile)
                }, section.image.mobile)), /*#__PURE__*/_jsx("div", {
                  className: styles.textWrapper,
                  children: /*#__PURE__*/_jsx(Text, {
                    richText: true,
                    className: styles.text,
                    typog: "bodycopyLarge",
                    children: section.text
                  })
                })]
              })]
            })
          })
        }, "section-".concat(index));
      })]
    }), footerText && /*#__PURE__*/_jsx(Text, {
      align: "center",
      richText: true,
      className: styles.footer,
      typog: "bodycopyExtraSmall",
      children: footerText
    }), button && /*#__PURE__*/_jsx("div", {
      className: styles.button,
      children: /*#__PURE__*/_jsx(Button, _objectSpread({}, button))
    })]
  });
};